export var classNames = function () {
    var classNames = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classNames[_i] = arguments[_i];
    }
    if (!classNames || classNames.length === 0)
        return '';
    return classNames.join(' ');
};
export var utilityGroups = {
    fontSize: /^text-(xs|sm|base|lg|[2-9]?xl|\d+)$/,
    fontWeight: /^font-(thin|extralight|light|normal|medium|semibold|bold|extrabold|black)$/,
    fontFamily: /^font-(body|h1|sans|serif|mono)$/,
    borderWidth: /^border(-\d+)?$/,
};
export var withoutOverriddenBy = function (styles, className, groups) {
    if (!className)
        return styles;
    var callerClasses = className.split(/\s+/);
    var overridden = groups.filter(function (group) {
        return callerClasses.some(function (c) { return group.test(c); });
    });
    if (!overridden.length)
        return styles;
    return styles
        .split(/\s+/)
        .filter(function (c) { return c && !overridden.some(function (group) { return group.test(c); }); })
        .join(' ');
};
//# sourceMappingURL=style-class.utils.js.map